<template>
  <div v-if="display" class="search-open-close-button-expansion-bar">
    <q-btn color="primary" flat class="full-width" @click="openClose">
      <q-icon left :name="open ? 'mdi-chevron-double-up' : 'mdi-chevron-double-down'" />
    </q-btn>
  </div>
</template>
<script setup lang="ts">
interface Props {
  display: boolean;
  open: boolean | true;
}
const props = defineProps<Props>();

const emit = defineEmits<{
  (event: 'open', opened: boolean): void;
}>();
const openClose = () => {
  let opened = props.open;
  if (opened) {
    opened = false;
  } else {
    opened = true;
  }
  emit('open', opened);
};
</script>
<style scoped>
.search-open-close-button-expansion-bar {
  border-bottom: 1px solid var(--q-primary);
}
</style>
